export const mapSearchParamsToWizardType = (
  searchParams: URLSearchParams
): PvWizardResultsQueryVariables => {
  const searchParamsObj = Object.fromEntries(searchParams.entries());
  const { roofAge, roofMaterial, ...restSearchParams } = searchParamsObj;
  const mappedAnswers = {
    ...restSearchParams,
    ...((roofAge || roofMaterial) && {
      roofDetails: { ...(roofAge && { roofAge }), ...(roofMaterial && { roofMaterial }) }
    })
  };
  return mappedAnswers;
};
